// extracted by mini-css-extract-plugin
export var button = "InstagramCta-module--button--yHZ2v";
export var container = "InstagramCta-module--container--X2HGf";
export var content = "InstagramCta-module--content--OCWIi";
export var eyelash = "InstagramCta-module--eyelash--Xg3mJ";
export var imageWrapper = "InstagramCta-module--imageWrapper--jdXe-";
export var subTitle = "InstagramCta-module--subTitle--8xZXj";
export var title = "InstagramCta-module--title--Cu1Qu";